












import SimpleInput from '@/UI/Shared/SimpleInput.vue'
import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'
import { AccountId } from '@/Domain/Account'

export default mixins(FieldModel).extend({
  name: 'NifInput',
  components: { SimpleInput },
  data () {
    return {
      isValid: true
    }
  },
  computed: {
    inputStatus (): string {
      if (this.currentValue === '') {
        return ''
      }
      return this.isValid
        ? 'success'
        : 'danger'
    },
    errorMessage (): string {
      return this.inputStatus === 'danger'
        ? this.$t('subasta.persoais.wrong-nif').toString()
        : ''
    }
  },
  methods: {
    validateInput ($event: string) {
      if ($event === '') {
        this.$emit('input', '')
        this.isValid = false
      }
      const uppercasedEvent = $event.toUpperCase()
      try {
        const accountId = new AccountId(uppercasedEvent)
        this.isValid = true
        this.$emit('input', accountId.accountId())
      } catch (error) {
        this.isValid = false
      }
    }
  }
})
